export default {"src":"/_next/static/media/waiver-acknowledgements.65ab9b33.svg","height":125,"width":140,"blurWidth":0,"blurHeight":0};